<script setup lang="ts">
interface StackedPropertyImagesProps {
	imageUrl?: string | null;
	images?: Array<string | null>;
}

const props = withDefaults(defineProps<StackedPropertyImagesProps>(), {
	imageUrl: null,
	images: () => []
});

// Use images array if provided, otherwise fallback to single imageUrl
const displayImages = computed(() => {
	if (props.images && props.images.length > 0) {
		// For 2 stacked images, we want different images
		const result: Array<string | null> = [];

		// First image: from first property/source
		result.push(props.images[0] || null);

		// Second image: from second property/source if available,
		// otherwise second image from first property/source
		if (props.images.length > 1) {
			result.push(props.images[1] || null);
		} else if (props.images.length === 1) {
			result.push(props.images[0] || null);
		}

		return result;
	}
	return props.imageUrl ? [props.imageUrl] : [];
});

// Get images for background and foreground
const backgroundImage = computed(() => {
	return displayImages.value[1] || displayImages.value[0] || null;
});

const foregroundImage = computed(() => {
	return displayImages.value[0] || null;
});
</script>

<template>
	<div class="relative flex w-[100px] flex-col gap-[5.641px]">
		<!-- Background image (slightly offset) -->
		<div
			class="absolute -bottom-1.5 -left-1.5 h-[75px] w-[100px] overflow-hidden rounded-[2.5px] border-2 border-white bg-white-dark-2 shadow-[0px_4px_8px_3px_rgba(0,0,0,0.15)]"
		>
			<NuxtImg
				v-if="backgroundImage"
				:src="backgroundImage"
				class="size-full object-cover"
				loading="lazy"
				format="webp"
				width="100"
				quality="70"
			/>
		</div>
		<!-- Foreground image -->
		<div
			class="relative z-10 h-[75px] w-[100px] overflow-hidden rounded-[2.5px] border-2 border-white bg-white-dark-2 shadow-[0px_4px_8px_3px_rgba(0,0,0,0.15)]"
		>
			<NuxtImg
				v-if="foregroundImage"
				:src="foregroundImage"
				class="size-full object-cover"
				loading="lazy"
				format="webp"
				width="100"
				quality="70"
			/>
		</div>
	</div>
</template>
